module.exports = __webpack_public_path__ + "static/transaction_fee_management2-f2000eb8b70699933aefd756dc24ba87.png";